import { Stack, router, type Href } from 'expo-router';
import type { SFSymbol } from 'sf-symbols-typescript';

type NavigationBackToolbarProps = Readonly<{
  fallbackHref: Href;
  label?: string;
}>;

export function NavigationBackToolbar({
  fallbackHref,
  label = 'Back',
}: NavigationBackToolbarProps) {
  function goBack() {
    if (router.canGoBack()) {
      router.back();
      return;
    }

    router.replace(fallbackHref);
  }

  return (
    <Stack.Toolbar placement="left">
      <Stack.Toolbar.Button
        accessibilityLabel={label}
        icon={toolbarIcon('chevron.left')}
        onPress={goBack}
      >
        {toolbarFallbackLabel(label)}
      </Stack.Toolbar.Button>
    </Stack.Toolbar>
  );
}

function toolbarIcon(icon: SFSymbol) {
  return process.env.EXPO_OS === 'ios' ? icon : undefined;
}

function toolbarFallbackLabel(label: string) {
  return process.env.EXPO_OS === 'ios' ? undefined : label;
}
